import { DownOutlined } from '@ant-design/icons';
import { Col, Dropdown, Menu, Row } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CardToolbox } from '../../container/styled';
import plus from '../../static/img/balken/agregar_BALKEN.png';
import arrow from '../../static/img/balken/regresar_BALKEN_1.svg';
import { Button } from '../buttons/buttons';
import { PageHeader } from '../page-headers/page-headers';

const ICONS = {
  arrow,
  plus,
};

// Subcomponente: Botón de acción principal
const ActionButton = ({ label, link, icon, type, size }) => {
  if (!label) return null;

  return (
    <Col>
      <Link to={link}>
        <Button type={type} size={size}>
          {icon && <img src={icon} alt="icon" style={{ marginRight: 6 }} />}
          {label}
        </Button>
      </Link>
    </Col>
  );
};

// Subcomponente: Renderizado de elementos adicionales como columnas
const RenderExtraElements = ({ elements }) => elements.map((element, index) => <Col key={index}>{element}</Col>);

// Subcomponente: Dropdown para filtros cuando hay muchos
const ExtraElementsDropdown = ({ elements, onOpenChange, open }) => {
  const handleMenuClick = (e) => {
    e.domEvent.stopPropagation();
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {elements.map((element, index) => (
        <Menu.Item key={index}>{element}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} onOpenChange={onOpenChange} open={open}>
      <Button type="dark" outlined size="large" onClick={(e) => e.preventDefault()}>
        Mostrar filtros <DownOutlined />
      </Button>
    </Dropdown>
  );
};

// Componente principal
function HeaderCard({
  title,
  buttonLabel,
  buttonLink,
  buttonIcon,
  buttonType = 'primary',
  buttonSize = 'large',
  ghost = true,
  extraElements = [],
  extraActions = [],
  dropdown = true
}) {
  const buttonIconSrc = ICONS[buttonIcon] || null;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const renderElements = () => {
    if (extraElements.length >= 3 && dropdown) {
      return (
        <Col>
          <ExtraElementsDropdown elements={extraElements} onOpenChange={setDropdownOpen} open={dropdownOpen} />
        </Col>
      );
    }
    return <RenderExtraElements elements={extraElements} />;
  };

  return (
    <CardToolbox>
      <PageHeader
        ghost={ghost}
        title={title}
        buttons={[
          <Row gutter={[25, 25]} key="buttons-row" justify="end" align="middle">
            {renderElements()}
            {extraActions && extraActions.map((action, index) => <Col key={index}>{action}</Col>)}
            {/* Botón de acción principal */}
            <ActionButton
              label={buttonLabel}
              link={buttonLink}
              icon={buttonIconSrc}
              type={buttonType}
              size={buttonSize}
            />
          </Row>,
        ]}
      />
    </CardToolbox>
  );
}

export default HeaderCard;
